import { IPartner } from '@/modules/partner/model';
import { SELF_EMPLOYED } from '@/modules/partner/model/partnerType';

export const isCompany = (partner: IPartner) => partner.partnerType !== SELF_EMPLOYED;
export const isSelfEmployed = (partner: IPartner) => partner.partnerType === SELF_EMPLOYED;
